import * as React from 'react';
import classNames from 'classnames';

import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const styles = require('./styles.pcss');

const CreditCardTableHead = () => (
  <TableHead>
    <TableRow>
      <TableCell className={classNames(styles.tableHead)}>Name</TableCell>
      <TableCell className={classNames(styles.tableHead)}>Type</TableCell>
      <TableCell className={classNames(styles.tableHead)}>Last 4</TableCell>
      <TableCell className={classNames(styles.tableHead)}>Exp Date</TableCell>
      <TableCell className={classNames(styles.tableHead)}>
        Corporate Card
      </TableCell>
    </TableRow>
  </TableHead>
);

export default CreditCardTableHead;
